import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { AuthProvider } from "./hooks/auth";
import Layout from "./components/Layout";

import Routes from "./routes";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Layout>
          <Routes />
          <ToastContainer />
        </Layout>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
